import { Tag, type TagVariant } from '@components';
import { Box, Divider, Tooltip, Typography } from '@mui/material';
import type { ReactElement } from 'react';

import { TIER_TYPE_LABELS, type TierEntry } from '@web/components/TierBadges/TierBadges';

type DrawerTierBadgesProps = {
  tiers: TierEntry[];
};

export const DrawerTierBadges = ({ tiers }: DrawerTierBadgesProps): ReactElement => {
  const getTierVariant = (type: string): TagVariant => {
    switch (type) {
      case 'fixed':
        return 'Blue';
      case 'list price':
        return 'Secondary';
      default:
        return 'Tertiary';
    }
  };

  const sorted = [...tiers].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <Divider />
      <Typography variant='h2' paddingTop='0.25rem'>
        Tiers
      </Typography>
      <Box display='flex' flexWrap='wrap' gap='0.5rem'>
        {sorted.map((tier) => (
          <Tooltip key={tier.name} title={TIER_TYPE_LABELS[tier.type] ?? tier.type}>
            <Tag variant={getTierVariant(tier.type)} label={tier.name} />
          </Tooltip>
        ))}
      </Box>
      <Typography variant='body2' color='text.secondary'>
        Pricing is managed in Tiered Price Configs. Changes to pricing must be made there.
      </Typography>
    </Box>
  );
};
